import {
  DASHBOARD_START,
  DASHBOARD_STATUS_COUNTS,
  DASHBOARD_WINNERS_COUNT,
  DASHBOARD_PRIZE_AMOUNT,
  DASHBOARD_CHANNEL_COUNTS,
  DASHBOARD_TRANSACTIONS,
  DASHBOARD_END,
} from '../../slices/dashboard/dashboard';

interface DashboardState {
  loading: boolean;
  statusCounts: any;
  winnersCount: any;
  prizeAmount: any;
  channelCounts: any;
  transactions: any;
}

const initialState: DashboardState = {
  loading: false,
  statusCounts: null,
  winnersCount: null,
  prizeAmount: null,
  channelCounts: null,
  transactions: null,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const Dashboard_Red = (state = initialState, action: Action): DashboardState => {
  switch (action.type) {
    case DASHBOARD_START:
      return { ...state, loading: true };
    case DASHBOARD_STATUS_COUNTS:
      return { ...state, statusCounts: action.payload, loading: false };
    case DASHBOARD_WINNERS_COUNT:
      return { ...state, winnersCount: action.payload, loading: false };
    case DASHBOARD_PRIZE_AMOUNT:
      return { ...state, prizeAmount: action.payload, loading: false };
    case DASHBOARD_CHANNEL_COUNTS:
      return { ...state, channelCounts: action.payload, loading: false };
    case DASHBOARD_TRANSACTIONS:
      return { ...state, transactions: action.payload, loading: false };
    case DASHBOARD_END:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default Dashboard_Red;
